import {FC, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {PlayerCard, PlayerInfo, PlayerName, PlayerTop} from "components/Common";
import {getPlayerName, toLowerCase} from "modules/utils";
import {IPlayer} from "modules/types";
import {PlayerPositionEnum} from "modules/enums";
import {IS_PLAYER_MODAL_DISABLED} from "modules/constants";
import {openPlayerDetailsModal} from "modules/actions";
import {Jersey, SquadLogo} from "components";

interface IProps {
	player: IPlayer;
	position: PlayerPositionEnum;
}

export const RowItem: FC<IProps> = ({position, player}) => {
	const dispatch = useDispatch();
	const {t} = useTranslation();

	const openPlayerModalHandler = useCallback(() => {
		if (!IS_PLAYER_MODAL_DISABLED) {
			dispatch(openPlayerDetailsModal({id: player.id}));
		}
	}, [player, dispatch]);

	return (
		<PlayerCard className="player-card" onClick={openPlayerModalHandler}>
			<PlayerTop>
				<Jersey image={player.image} alt={player.firstName} />

				<SquadLogo squadId={player.squadId} />
			</PlayerTop>

			<PlayerInfo className="player-card-info">
				<PlayerName className="player-card-name">{getPlayerName(player)}</PlayerName>
				<div className="player-card-position">
					{t(toLowerCase(`game.position.${position}`))}
				</div>
			</PlayerInfo>
		</PlayerCard>
	);
};
